import { html } from "lit";
var icon_delete_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8 2a2.8 2.8 0 0 1 2.8 2.8v.93h7.47a.93.93 0 0 1 .12 1.86l-.12.01h-1.95l-1.65 19.83A2.8 2.8 0 0 1 22.86 30l-.18.01H9.32a2.8 2.8 0 0 1-2.8-2.57L4.88 7.6H2.93a.93.93 0 0 1-.12-1.86h7.59V4.8A2.8 2.8 0 0 1 13.03 2h5.77Zm6.45 5.6H6.75l1.64 19.68c.03.44.37.78.8.84l.13.01h13.36c.49 0 .9-.37.93-.85L25.25 7.6ZM13.2 12.27c.47 0 .86.35.92.8l.01.13v9.33a.93.93 0 0 1-1.85.13l-.01-.13V13.2c0-.52.41-.93.93-.93Zm5.6 0c.47 0 .86.35.92.8l.01.13v9.33a.93.93 0 0 1-1.85.13l-.01-.13V13.2c0-.52.41-.93.93-.93Zm0-8.4h-5.6a.93.93 0 0 0-.93.93v.93h7.46V4.8a.93.93 0 0 0-.8-.92l-.13-.01Z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_delete_default as default
};
//# sourceMappingURL=icon-delete.js.map
